export enum ResponseCode {
  SUCCESS = "IMMS-00-000"

}
